import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import "../styles/Regform.css";
import HrDropdown from "./HrDropdown";
import moment from "moment";
import { Button, message, Select, DatePicker, Alert } from "antd";
import useAuth from "../hooks/useAuth";
import debounce from 'lodash.debounce';

const { Option } = Select;
const URL = process.env.REACT_APP_API_URL;

const Postjob = () => {
  // const { role } = useParams();

  const analyticsAndInsights = ['Adobe Support', 'Data Engineering and Data Governance', 'Data Science', 'Dell_DCF Moderation', 'Dell_KM, VA & Community Data Analytics and Visualization', 'Digital Analytics', 'Motilal Oswal_Analytics', 'National Business Furniture_Analytics', 'Partstown_Analytics', 'TBC (To Be Confirmed)'];
  const edTechAndCatalogOperations = ['Dell, Enterprise Data Management', 'Dell_DCF_Support project', 'Dell_Fusion Support', 'Dell_SKU Audit Support', 'Dell_SKU Lifecycle Management', 'EdTech & Catalog Operations (ECO)', 'ExamSoft', 'ProctorExam_R&R - LP', 'ProctorExam_Tech Support', 'TBC (To Be Confirmed)'];
  const pacsProject = ['PACS - Maharashtra', 'PACS - Punjab', 'TBC (To Be Confirmed)'];
  const sharedServices = ['Accounts', 'Administration', 'Business Development', 'Human Resources', 'IT & Network', 'Knowledge Management - Corporate Communications', 'Knowledge Management - Graphic and Creative Support', 'Knowledge Management - Learning & Development', 'TBC (To Be Confirmed)'];
  const dataAndDigital = ['AJIO_B2C Catalog', 'Allied Wire and Cable_PDE', 'Alphonso_Ad Clipping', 'Alphonso_ADomain categorization', 'Anoki_Metadata Creation', 'Digital Marketing', 'EDM_Reserved Strength', 'Grainger_Content Writing', 'ISG_Metadata Creation', 'National Business Furniture_Search', 'National Business Furniture_SEO', 'Quantiphi - Alphonso', 'Quantiphi - QDOX', 'Quantiphi - Viacom', 'Quantiphi_Account Enrichment', 'Quantiphi_AFLAC', 'Quantiphi_Aramco Lens', 'Quantiphi_Bison Transport', 'Quantiphi_Bunge Hyper care', 'Quantiphi_COR', 'Quantiphi_Disney', 'Quantiphi_Dociphi', 'Quantiphi_Dociphi LIT', 'Quantiphi_Ecolab', 'Quantiphi_Gallagher', 'Quantiphi_Genworth', 'Quantiphi_Graphite Connect', 'Quantiphi_Hamilton', 'Quantiphi_HSBC', 'Quantiphi_IEE', 'Quantiphi_Illinois tech', 'Quantiphi_LinkedIn Enrichment', 'Quantiphi_Logitech', 'Quantiphi_Logitech 2.0', 'Quantiphi_LSC', 'Quantiphi_Marsh Italy Mediclaim', 'Quantiphi_Marsh Loss Runs HITL',
    'Quantiphi_Mr.Cooper', 'Quantiphi_QBE', 'Quantiphi_Sanmina Corp', 'Quantiphi_Sound Physicians', 'Quantiphi_STC', 'Quantiphi_USI', 'Quantiphi_Weight watchers', 'Ripik', 'Sunlight_API Testing', 'Tagging_Reserved Strength', 'Transform CX_Content Management', 'Wolseley Express_Analytics', 'Wolseley Express_Connects Support', 'Wolseley Express_eComm Support', 'Wolseley Express_Marketing Support', 'Wolseley Express_PDE', 'TBC (To Be Confirmed)'];
  // const testProject = ['Test_Reserved', 'Test_Reserved Strength - 2'];
  const { token, auth, role } = useAuth();
  const [mgrRole, setMgrRole] = useState("");
  const [formData, setFormData] = useState({
    position: "",
    vertical: auth.role === 'HiringManager' ? Array.isArray(auth.vertical) ? auth.vertical[0] || '' : typeof auth.vertical === 'string' ? auth.vertical : '' : '',
    department: "",
    designation: "",
    typeOfHiring: "",
    positionId: "",
    description: "",
    jobLocation: "",
    vacancies: "",
    primarySkills: [],
    secondarySkills: [],
    experience: "",
    postedBy: auth.fullName,
    status: "Waiting for Approval",
    mgrRole: role,
    jd: "",
    fullfilledBy: "",
    toEmail: "",
    responsibilities: "",
    updateBy: auth.fullName,
    billingStatus: "",
    postedByEmail: auth.email,
    note: auth.role === 'Admin' ? "" : undefined,// Only store if Admin
    replacedEmployee: [],
    //comments: ""
  });

  const [errors, setErrors] = useState({
    position: [],
    jobLocation: [],
    primarySkills: [],
    secondarySkills: [],
    description: [],
    responsibilities: []
  });

  const checkGrammar = async (field, text) => {
    if (!text.trim()) {
      setErrors((prev) => ({ ...prev, [field]: [] }));
      return;
    }

    try {
      const res = await axios.post(
        'https://api.languagetoolplus.com/v2/check',
        null,
        {
          params: {
            text,
            language: 'en-US',
          },
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );
      console.log('response', res);

      setErrors((prev) => ({ ...prev, [field]: res.data.matches }));
    } catch (err) {
      console.error(`Error checking ${field}:`, err);
    }
  };

  // Debounced checker
  const debouncedCheckGrammar = useCallback(
    debounce((field, value) => checkGrammar(field, value), 600),
    []
  );

  // Debounced checker
  // const debouncedCheckGrammar = () => {
  //   debounce((field, value) => checkGrammar(field, value), 600);
  // };

  const [selectedHrName, setSelectedHrName] = useState("");
  const [selectedHrEmail, setSelectedHrEmail] = useState("");
  const [replacedEmployee, setReplacedEmployee] = useState("");


  useEffect(() => {
    setMgrRole(role); // Role from useAuth hook
    setFormData((prevData) => ({
      ...prevData,
      mgrRole: auth.role,
    }));
  }, [role]);


  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      updateBy: auth.fullName,
      postedBy: auth.fullName,
      postedByEmail: auth.email,
    }));
  }, [auth.fullName]);

  const designations = {
    'Associate - A': 'A',
    'Senior Associate - SA': 'SA',
    'Assistant Project Manager - APM': 'APM',
    'Project Manager - PM L1': 'PM-L1',
    'Project Manager - PM L2': 'PM-L2',
    'Assistant Vice President - AVP': 'AVP',
    'Vice President - VP': 'VP',
    'President - P': 'P',
    'STP - Consultant': 'STP-C',
    'Associate_Data Processing_Mumbai': 'ADP-M',
    'Associate_Data Processing': 'ADP',
    'STP_Data Processing': 'STP-DP',
    'Associate CA': 'A-CA',
    'Associate Accounts': 'AA',
    'Trainee Associate': 'TA'
  };

  const designationList = Object.keys(designations);


  const deptEmailMap = {
    "Analytics n Insights (ANI)": "imran@enfuse-solutions.com",
    "Software Services": "imran@enfuse-solutions.com",
    "EdTech & Catalog Operations (ECO)": "imran@enfuse-solutions.com",
    "PACS Project": "imran@enfuse-solutions.com",
    "Shared Services": "kamran@enfuse-solutions.com",
    "Data and Digital (DnD)": "kamran@enfuse-solutions.com",
    "Legal & Finance (LnF)": "kamran@enfuse-solutions.com",
    "Shared Services_ BD & KM": "imran@enfuse-solutions.com",
    // "Test":"farahnaz.saiyed@enfuse-solutions.com"
  };

  const deptList = Object.keys(deptEmailMap);

  const handleVerticalChange = (vertical) => {
    const email = deptEmailMap[vertical] || ""; // Get email from mapping
    console.log("Vertical selected:", vertical, "toEmail:", email);

    setFormData((prevData) => ({
      ...prevData,
      vertical,
      toEmail: email, // Update toEmail here
    }));

    // Reset department if vertical changes
    if (formData.department) {
      setFormData((prevData) => ({
        ...prevData,
        department: "",
      }));
    }
  };

  const handleDesignation = (designationType) => {
    const designation = designationType || "";

    setFormData((prevData) => ({
      ...prevData,
      designation,
    }));

    // Update positionId
    if (formData.vertical) {
      let generatedPositionId;    //= `${formData.department}-${designation}-00001`;

      if (formData.vertical === "Analytics n Insights (ANI)")
        generatedPositionId = `ANI-${designation}`;
      else if (formData.vertical === "Software Services")
        generatedPositionId = `SoS-${designation}`;
      else if (formData.vertical === "EdTech & Catalog Operations (ECO)")
        generatedPositionId = `ECO-${designation}`;
      else if (formData.vertical === "PACS Project")
        generatedPositionId = `PACS-${designation}`;
      else if (formData.vertical === "Shared Services")
        generatedPositionId = `Shared-Services-${designation}`;
      else if (formData.vertical === "Data and Digital (DnD)")
        generatedPositionId = `DnD-${designation}`;
      else if (formData.vertical === "Legal & Finance (LnF)")
        generatedPositionId = `LnF-${designation}`;
      else if (formData.vertical === "Shared Services_ BD & KM");
        generatedPositionId = `SSBD-${designation}`;


      console.log('generatedPositionId: ', generatedPositionId);

      setFormData((prev) => ({
        ...prev,
        positionId: generatedPositionId,
      }));
    }
  }

  const handleDepartmentChange = (departmentType) => {
    const department = departmentType || "";

    setFormData((prevData) => ({
      ...prevData,
      department,
    }));

  }

  const handleHiringTypeChange = (hiringType) => {
    const typeOfHiring = hiringType || "";

    setFormData((prevData) => ({
      ...prevData,
      typeOfHiring,
    }));
  }

  const handleIsLiveChange = (value) => {
    const isLive = value;

    setFormData((prevData) => ({
      ...prevData,
      isLive,
    }));
  }

  const isAlphabetic = (value) => /^[A-Za-z\s,+\-]*$/.test(value);
  const isNumeric = (value) => /^[0-9]*$/.test(value);

  const validateField = (name, value) => {
    if (name === "experience" || name === "vacancies") {
      if (!isNumeric(value)) {
        message.error(`${name} should contain only numbers`);
        return false;
      }
    } else if (
      name !== "department" &&
      name !== "postedBy" &&
      name !== "position" &&
      name !== "responsibilities" &&
      name !== "description"
    ) {
      if (!isAlphabetic(value)) {
        message.error(
          `${name} should contain only alphabets, spaces, commas, +, or -`
        );
        return false;
      }
    }
    return true;
  };

  const handlePaste = (e) => {
    const { name } = e.target;
    const clipboardData = e.clipboardData || window.clipboardData;
    const pastedText = clipboardData.getData("Text");

    if (name === "responsibilities" || name === "description") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: pastedText,
      }));
    }
  };

  const handleChange = async (e) => {
    //e.preventDefault();

    if (e.target.name === "jd") {
      const file = e.target.files[0];
      const allowedExtensions = /(\.pdf|\.doc)$/i;

      if (!allowedExtensions.exec(file.name)) {
        message.error("Please upload a file in .pdf or .doc format");
        return;
      }

      const uploadFormData = new FormData();
      uploadFormData.append(e.target.name, file, file.name);

      const uploadEndpoint = e.target.name;
      const response = await fetch(`${URL}/api/upload/` + uploadEndpoint, {
        method: "POST",
        body: uploadFormData,
      });

      if (!response.ok) {
        console.error("File upload failed with status code", response.status);
      } else {
        console.log("File uploaded successfully");
      }

      const data = await response.json();
      setFormData((prevData) => ({
        ...prevData,
        [e.target.name]: data["uploadedFile"],
      }));
    } else {
      const { name, value } = e.target;
      // if (validateField(name, value)) {
      //   setFormData((prevData) => ({
      //     ...prevData,
      //     [name]: value,
      //   }));
      // }
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));

      // Run validation separately
      validateField(name, value);


      // Trigger grammar check for relevant fields
      if (['position', 'jobLocation', 'responsibilities', 'description'].includes(name)) {
        debouncedCheckGrammar(name, value);
      }
    }
  };

  const MAX_MATCHES = 7;
  const MAX_REPLACEMENTS_PER_MATCH = 7;

  const renderSuggestions = (matches) => {
    const limitedMatches = (matches || []).slice(0, MAX_MATCHES);

    return (
      <ul style={{ color: 'red', margin: '0 0 20px 0', paddingLeft: '20px' }}>
        {limitedMatches.map((m, idx) => {
          const reps = (m.replacements || []).slice(0, MAX_REPLACEMENTS_PER_MATCH);
          {/* const more = (m.replacements?.length || 0) - reps.length; */ }

          return (
            <li key={idx}>
              <strong>{m.context?.text ?? ''}</strong> ➤{' '}
              {reps.length
                ? `Try: ${reps.map((r) => r.value).join(', ')}`//${more > 0 ? ` … (+${more} more)` : ''}`
                : m.message}
            </li>
          );
        })}
      </ul>
    );
  };



  const disabledDate = (current) => {
    // Disable dates before today and after 60 days from today
    const today = moment();
    const maxDate = moment().add(240, 'days');
    return current && (current < today.startOf('day') || current > maxDate.endOf('day'));
  };

  const handleDateChange = (date, dateString) => {
    if (date && date.isBefore(moment(), "day")) {
      message.error("Fullfilled By date should be a future date");
      setFormData((prevData) => ({
        ...prevData,
        fullfilledBy: "",
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        fullfilledBy: dateString,
      }));
    }
  };

  const handleSelectChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSelectHr = (fullName, email) => {
    setSelectedHrName(fullName);
    setSelectedHrEmail(email);
    setFormData((prevData) => ({
      ...prevData,
      postedBy: fullName,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields
    const requiredFields = [
      "position",
      "department",
      "jobLocation",
      "vacancies",
      "primarySkills",
      "experience",
      "jd",
      "fullfilledBy",
    ];

    // If Replacement-Hiring → replacedEmployee required
    if (formData.typeOfHiring === "Replacement-Hiring") {
      requiredFields.push("replacedEmployee");
    }

  for (let field of requiredFields) {
    if (
      !formData[field] ||
      (typeof formData[field] === "string" && formData[field].trim() === "") ||
      (Array.isArray(formData[field]) && formData[field].length === 0)
    ) {
      message.error(`${field === "isLive" ? "Go Live" : field} is required`);
      return;
    }
  }

    try {
      // Director / Dept email
      const currentToEmail = deptEmailMap[formData.vertical] || "";

      // ----------- BUILD CLEAN JOB PAYLOAD -----------
      const jobData = {
        ...formData,
        mgrRole: auth.role, 
        toEmail: currentToEmail,
        note: auth.role === "Admin" ? formData.note : undefined,
      };

      // ----------- CREATE JOB (WORKING FIXED CALL) -----------
      const response = await axios.post(
        `${URL}/api/createjob`,
        jobData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const { _id: jobId, postedByEmail } = response.data;

      message.success("New Job created successfully and sent for Directors Approval");

      // ----------- BUILD APPROVAL EMAIL PAYLOAD -----------
      const emailData = {
        position: formData.position,
        department: formData.department,
        postedBy: formData.postedBy,
        jobId,
        toEmail: currentToEmail,
        postedByEmail,
        note: auth.role === "Admin" ? formData.note : undefined,
      };

      // ----------- SEND APPROVAL MAIL -----------
      await axios.post(
        `${URL}/api/job/approval`,
        emailData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // ----------- RESET FORM -----------
      setFormData({
        position: "",
        department: "",
        description: "",
        jobLocation: "",
        vacancies: "",
        primarySkills: [],
        secondarySkills: [],
        experience: "",
        postedBy: "",
        responsibilities: "",
        jd: "",
        fullfilledBy: "",
        note: "",
        replacedEmployee: "",
        typeOfHiring: "",
      });

    setSelectedHrName("");
    setSelectedHrEmail("");

    } catch (error) {
      if (error.response?.status === 409) {
        message.error("Job Postings with same Position IDs are not allowed.");
      }

      console.error("Error:", error);
      message.error("An error occurred while creating the job.");
    }
  };



  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="formContainer">
          <div className="block">
            <div>
              <label htmlFor="position">
                Job Title:<span className="require">*</span>
              </label>
              <input
                type="text"
                name="position"
                id="position"
                value={formData.position}
                onChange={handleChange}
                required
                placeholder="Job Title"
              />
              {errors.position.length > 0 && renderSuggestions(errors.position)}
            </div>
            <div>
              <label htmlFor="vacancies">
                Vacancies:<span className="require">*</span>
              </label>
              <input
                type="text"
                name="vacancies"
                id="vacancies"
                value={formData.vacancies}
                onChange={handleChange}
                required
                
              />
            </div>
            <div>
              <label htmlFor="primarySkills">
                Primary Skills:<span className="require">*</span>
              </label>
              <Select
                mode="tags"
                placeholder="Enter skill & press Enter Key"
                value={formData.primarySkills}
                onChange={(value) => handleSelectChange("primarySkills", value)}
                required
              >
                {formData.primarySkills.map((skill, index) => (
                  <Option key={index} value={skill}>
                    {skill}
                  </Option>
                ))}
              </Select>
            </div>
            {(auth.role === 'Admin' || auth.role === 'HR') &&
              <div>
                <label htmlFor="vertical">
                  Vertical :<span className="require">*</span>
                </label>
                <Select
                  // value={auth.role === 'HiringManager' ? auth.vertical : formData.vertical}
                  value={formData.vertical}
                  onChange={handleVerticalChange}
                  required
                  placeholder="Choose One"
                // disabled={auth.role === 'HiringManager'}
                >
                  {deptList.map((dept) => (
                    <option key={dept} value={dept}>
                      {dept}
                    </option>
                  ))}
                </Select>
              </div>
            }
            {(auth.role === 'HiringManager' && typeof auth.vertical === 'string') &&
              <div>
                <label htmlFor="vertical">
                  Vertical :<span className="require">*</span>
                </label>
                <Select
                  // value={auth.role === 'HiringManager' ? auth.vertical : formData.vertical}
                  value={formData.vertical}
                  onChange={handleVerticalChange}
                  required
                  disabled={true}
                  placeholder="Choose One"
                >
                  {deptList.map((dept) => (
                    <option key={dept} value={dept}>
                      {dept}
                    </option>
                  ))}
                </Select>
              </div>
            }
            {(auth.role === 'HiringManager' && Array.isArray(auth.vertical)) &&
              <div>
                <label htmlFor="vertical">
                  Vertical :<span className="require">*</span>
                </label>
                <Select
                  // value={auth.role === 'HiringManager' ? auth.vertical : formData.vertical}
                  value={formData.vertical}
                  // defaultValue={auth.vertical[0]}
                  onChange={handleVerticalChange}
                  required
                  placeholder="Choose One"
                >
                  {auth.vertical.map((ver) => (
                    <option key={ver} value={ver}>
                      {ver}
                    </option>
                  ))}
                </Select>
              </div>
            }
            {/* {(auth.role === 'Admin' || auth.role === "HR") && */}
            <div>
              <label htmlFor="department">
                Department:<span className="require">*</span>
              </label>
              <Select
                value={formData.department}
                onChange={handleDepartmentChange}
                required
                placeholder="Choose One"
              >
                {formData.vertical === 'Software Services' && (
                  <>
                    
                    <option key='Vision Lab'>Vision Lab</option>
                    <Option key='Development'>Development</Option>
                    <Option key='QA'>QA</Option>
                    <Option key='Project Management'>Project Management</Option>
                    <option key='TBC (To Be Confirmed)' value='TBC (To Be Confirmed)'>TBC (To Be Confirmed)</option>
                  </>
                )}
                {
                  formData.vertical === 'Shared Services_ BD & KM' && (
                    <>
                      <option key='Business Development' value='Business Development'>Business Development</option>
                      <option key='Knowledge Management' value='Knowledge Management'>Knowledge Management</option>
                    </>
                  )
                }

                {
                  formData.vertical === 'Legal & Finance (LnF)' && (
                    <>
                      <option key='Legal' value='Legal'>Legal</option>
                      <option key='TBC (To Be Confirmed)' value='TBC (To Be Confirmed)'>TBC (To Be Confirmed)</option>
                    </>
                  )
                }
                {
                  formData.vertical === 'Analytics n Insights (ANI)' &&
                  analyticsAndInsights.map(elem => (
                    <option key={elem} value={elem}>
                      {elem}
                    </option>
                  ))
                }
                {
                  formData.vertical === 'EdTech & Catalog Operations (ECO)' &&
                  edTechAndCatalogOperations.map(elem => (
                    <option key={elem} value={elem}>
                      {elem}
                    </option>
                  ))
                }
                {
                  formData.vertical === 'Data and Digital (DnD)' &&
                  dataAndDigital.map(elem => (
                    <option key={elem} value={elem}>
                      {elem}
                    </option>
                  ))
                }
                {
                  formData.vertical === 'PACS Project' &&
                  pacsProject.map(elem => (
                    <option key={elem} value={elem}>
                      {elem}
                    </option>
                  ))
                }



                {
                  formData.vertical === 'Shared Services' &&
                  sharedServices.map(elem => (
                    <option key={elem} value={elem}>
                      {elem}
                    </option>
                  ))
                }
              </Select>
            </div>



            <div>
              <label htmlFor="fullfilledBy">
                {auth.role !== "HiringManager" ? "HR Turnaround Time" : "Ops Anticipated Time"}:
              </label>
              <DatePicker
                onChange={handleDateChange}
                format="YYYY-MM-DD"
                value={
                  formData.fullfilledBy ? moment(formData.fullfilledBy) : null
                }
              />
            </div><br />
            {/* {auth.role === "Admin" && (
              <div style={{ marginTop: "20px" }}>
                <label htmlFor="note">Admin Note:</label>
                <input
                  type="text"
                  name="note"
                  id="note"
                  placeholder="Note will be sent to Directors Email"
                  value={formData.note}
                  onChange={handleChange}
                />
              </div>
            )}
            {/* <div >
              <label htmlFor="billingStatus">
                Billing Status:<span className="require">*</span>
              </label>
              <Select
                id="billingStatus"
                value={formData.billingStatus}
                onChange={(value) => handleSelectChange("billingStatus", value)}
                placeholder="Select Billing Status"
              >
                <Option value="Billable">Billable</Option>
                <Option value="Non Billable">Non Billable</Option>
              </Select>
            </div> */}
            <div>
              <label htmlFor="billingStatus">
                Billing Status:<span className="require">*</span>
              </label>

              <Select
                id="billingStatus"
                value={formData.billingStatus}
                onChange={(value) => handleSelectChange("billingStatus", value)}
                placeholder="Select Billing Status"
              >
                
                    <Option value="Billed">Billed</Option>
                    <Option value="Unbilled">Unbilled</Option>
                    <Option value="Billed – Support">Billed – Support</Option>
                  
              </Select>
            </div>



          </div>
          <div className="block">

            <div>
              <label htmlFor="jobLocation">
                Location:<span className="require">*</span>
              </label>
              <input
                type="text"
                name="jobLocation"
                id="jobLocation"
                value={formData.jobLocation}
                onChange={handleChange}
                required
                placeholder="Enter Location"
                onPaste={handlePaste}
              />
              {errors.jobLocation.length > 0 && renderSuggestions(errors.jobLocation)}
            </div>
            <div>
              <label htmlFor="experience">
                Experience:<span className="require">*</span>
              </label>
              <input
                type="text"
                name="experience"
                id="experience"
                value={formData.experience}
                onChange={handleChange}
                required
                placeholder="Enter Experience in Years"
              />
            </div>
            <div>
              <label htmlFor="secondarySkills">Secondary Skills:</label>
              <Select
                mode="tags"
                placeholder="Enter skill & press Enter Key"
                value={formData.secondarySkills}
                onChange={(value) =>
                  handleSelectChange("secondarySkills", value)
                }
              >
                {formData.secondarySkills.map((skill, index) => (
                  <Option key={index} value={skill}>
                    {skill}
                  </Option>
                ))}
              </Select>
            </div>
            <div>
              <label htmlFor="designation">
                Designation:<span className="require">*</span>
              </label>
              <Select
                value={formData.designation}
                onChange={handleDesignation}
                required
                placeholder="Choose One"
              >
                {designationList.map((desgn) => (
                  <option key={desgn} value={designations[desgn]}>
                    {desgn}
                  </option>
                ))}
              </Select>
            </div>

            {auth.role !== "HiringManager" && (
              <div style={{}}>
                <label htmlFor="secondarySkills">HR</label>
                <HrDropdown
                  onSelect={handleSelectHr}
                  onSelectHr={handleSelectHr}
                  style={{ width: "100%" }}
                />
              </div>
            )}

            <div>
              <label htmlFor="typeOfHiring">
                Type Of Hiring:<span className="require">*</span>
              </label>
              <Select
                value={formData.typeOfHiring}
                onChange={handleHiringTypeChange}
                required
                placeholder="Choose One"
              >
                <Option value="New-Hiring">New-Hiring</Option>
                <Option value="Replacement-Hiring">Replacement-Hiring</Option>
                <Option value="Rehire">Rehire</Option>
              </Select>
            </div>

            {/*             
            {formData.typeOfHiring === "Replacement-Hiring" && (
              <div style={{ marginTop: '15px', marginBottom: '20px' }}>
                <label style={{ fontWeight: 'bold' }}>
                  Replacement Details <span className="require">*</span>
                </label>

                <table
                  style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    marginTop: '10px',
                    border: '1px solid #ccc'
                  }}
                >
                  <thead>
                    <tr style={{ background: '#f5f5f5' }}>
                      <th style={{ padding: '10px', border: '1px solid #ccc' }}>
                        * Name of Employee Being Replaced
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td style={{ padding: '10px', border: '1px solid #ccc' }}>
                        <input
                          type="text"
                          name="replacedEmployee"
                          value={formData.replacedEmployee}
                          onChange={handleChange}
                          placeholder="Enter employee name"
                          style={{
                            width: '100%',
                            padding: '8px',
                            borderRadius: '4px',
                            border: '1px solid #aaa'
                          }}
                          required
                        />

                      </td>
                    </tr>
                  </tbody>
                </table>
              </div> */}
            {/* )} */}
            {formData.typeOfHiring === "Replacement-Hiring" && (
              <div style={{ marginTop: "15px", marginBottom: "20px" }}>
                <label style={{ fontWeight: "bold" }}>
                  Replacement Details <span className="require">*</span>
                </label>

                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginTop: "10px",
                    border: "1px solid #ccc",
                  }}
                >
                  <thead>
                    <tr style={{ background: "#f5f5f5" }}>
                      <th style={{ padding: "10px", border: "1px solid #ccc" }}>
                        * Name(s) of Employee(s) Being Replaced
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td style={{ padding: "10px", border: "1px solid #ccc" }}>
                        <Select
                          mode="tags"
                          placeholder="Enter employee name & press Enter"
                          value={formData.replacedEmployee}
                          onChange={(value) =>
                            handleSelectChange("replacedEmployee", value)
                          }
                          style={{ width: "100%" }}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}


            <div>
              <label htmlFor="jd">
                JD:<span className="require">*</span>
              </label>

              <input
                type="file"
                name="jd"
                onChange={handleChange}
                accept=".pdf, .doc"
                required
              />
            </div>

            {/* <div>
              <label htmlFor="comments">
                Comments:<span className="require">*</span>
              </label>
              <textarea
                name="comments"
                id="comments"
                value={formData.comments}
                onChange={handleChange}
                required
                placeholder="Add any relevant notes or context"
              />
              {errors.comments?.length > 0 && renderSuggestions(errors.comments)}
            </div> */}

            {/* <div>
              <label htmlFor="isLive">
                This job can go live on Enfuse Website Careers Page?<span className="require">*</span>
              </label>
              <Select
                value={formData.isLive}
                onChange={handleIsLiveChange}
                required
              >
                <Option value='true'>Yes – Note- The job will also appear on the Careers Page once it receives Leadership approval</Option>
                <Option value='false'>No – Note- The job will not be visible on the Careers Page but will remain accessible within the internal CTS tool for hiring</Option>
              </Select>
            </div> */}
          </div>
        </div>

        <div id="desc">
           {auth.role === "Admin" && (
            <div style={{ marginTop: "20px" }}>
              <label htmlFor="note">Admin Note:</label>
              <textarea
                name="note"
                id="note"
                placeholder="Note will be sent to Directors Email"
                value={formData.note}
                onChange={handleChange}
              />
            </div>
          )}

           <div style={{marginBottom: '35px'}}>
            <label htmlFor="isLive">
              This job can go live on Enfuse Website Careers Page?<span className="require">*</span>
            </label>
            <Select
              value={formData.isLive}
              onChange={handleIsLiveChange}
              required
              placeholder="Choose One"
            >
              <Option value='true'>Yes, the job will appear on the Careers Page once it receives leadership approval, following a content audit by the content team.</Option>
              <Option value='false'>No, the job will not be visible on the Careers Page but will remain accessible within the internal CTS tool for hiring.</Option>
            </Select>
          </div>
        
          <div>
            <label htmlFor="rolesNResponsibilities">
              Roles & Responsibilities:<span className="require">*</span>
            </label>
            <textarea
              name="responsibilities"
              id="responsibilities"
              value={formData.responsibilities}
              onChange={handleChange}
            />
            {errors.responsibilities.length > 0 && renderSuggestions(errors.responsibilities)}
          </div>
          <div>
            <label htmlFor="description">Job Description:<span className="require">*</span></label>
            <textarea
              name="description"
              id="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Mention in 3 to 4 lines mandatory expectations that will reflect on EnFuse Careers Page"
            />
            {errors.description.length > 0 && renderSuggestions(errors.description)}
          </div>

        </div>
        <div id="btnWrapper">
          <button type="submit" className="form-btn" >
            Submit
          </button>
        </div>
      </form>
    </div>
  );

};

export default Postjob;


